import { request } from "./HttpService";
import { properties } from "../properties";

/**
 * Public on/off state for every app section, as { flags: { key: boolean } }.
 *
 * Deliberately a bare fetch (no Authorization header, no token-refresh retry)
 * rather than going through request(): /public/features is permit-all, but the
 * backend JWT filter still 403s on an *expired* Bearer token before the
 * permit-all matcher, and request()'s refresh path hard-redirects to "/" on a
 * dead session. Flag loading must stay fail-open and side-effect-free (it runs
 * on every page, including public showcase/profile pages for logged-out users),
 * so we never send a token here.
 */
export async function fetchPublicFeatureFlags() {
    const res = await fetch(properties.host + "/public/features", {
        headers: { "Content-Type": "application/json;charset=UTF-8" },
        cache: "no-store",
    });
    if (!res.ok) throw new Error(`features fetch failed: ${res.status}`);
    return res.json();
}

/** Admin: full flag objects (label, category, enabled, updatedAt, updatedBy). */
export function fetchAdminFeatureFlags() {
    return request("GET", "/admin/features");
}

/**
 * Admin: toggle a single section on/off. When disabling, an optional `autoEnableAt`
 * (epoch ms) arms a timer that auto-re-enables the section at that time; omit it (or
 * pass null) to disable indefinitely or to clear an existing timer.
 */
export function setFeatureFlag(key, enabled, autoEnableAt) {
    const body = { key, enabled };
    if (autoEnableAt != null) body.autoEnableAt = autoEnableAt;
    return request("PUT", "/admin/features", body);
}
